module.exports = __webpack_public_path__ + "img/ic_carroutx25.7ceae934.png";